import { useState, useEffect } from 'react';
import { useCriticalMeta } from './useCriticalMeta';
import { useQueryState } from './useQueryState';

export const useAppInitialization = () => {
  const [initialLoadPassed, setInitialLoadPassed] = useState();
  const { getCriticalMeta } = useCriticalMeta();
  const { dashboardConfig, queryError, queryLoading, isDataReady, revalidateAll } = useQueryState();

  // Once the dashboard config has resolved, kick off the rest of the
  // bootstrap fetches. Skip if we already passed/failed.
  useEffect(() => {
    if (!dashboardConfig || initialLoadPassed !== undefined) return;

    getCriticalMeta().then((result) => {
      setInitialLoadPassed(result.success);
    });
  }, [dashboardConfig, initialLoadPassed, getCriticalMeta]);

  const onReloadClicked = () => {
    setInitialLoadPassed(undefined);
    revalidateAll();
    getCriticalMeta().then((result) => {
      setInitialLoadPassed(result.success);
    });
  };

  const hasError = queryError || initialLoadPassed === false;
  const isLoading = queryLoading || !isDataReady || initialLoadPassed === undefined;

  return {
    hasError,
    isLoading,
    onReloadClicked
  };
};
